import type { SWRMutationConfiguration, SWRMutationResponse } from 'swr/mutation'
import useSWRMutation from 'swr/mutation'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UseRemoveTopicOptions {
  topicId: number | null
  config?: SWRMutationConfiguration<void, Error, string, undefined>
}

export const useRemoveTopic = ({
  topicId,
  config,
}: UseRemoveTopicOptions): SWRMutationResponse<void, Error, string | null, undefined> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.delete, undefined>({
    method: RequestMethodsEnum.delete,
    badRequestHandler: () => {},
    notFoundResponseHandler: () => {},
  })

  return useSWRMutation(
    topicId ? `/api/community/topic/${topicId}` : null,
    adaptFetcherToSWRMutationFn<void, undefined>(fetcher),
    config,
  )
}
